import {
    WORK_PREFRENCE_REQUEST,
    WORK_PREFRENCE_SUCCESS,
    WORK_PREFRENCE_FAIL
  } from "../constants/AuthConstant";
  
  import axios from "axios";
  import { toast } from "react-toastify";
  
  export const WorkPrefrenceAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: WORK_PREFRENCE_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/work_preference/add_work_preference`,
        method: "POST",
        data: data,
        headers: {
            "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(WorkPrefrencePre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: WORK_PREFRENCE_FAIL,
            payload: false,
            error: error,
            uploadProImg: error.success,
            msg: "Failed to Upload",
          });
          toast.error(error.msg);
        });
    };
  };
  
  export const WorkPrefrencePre = (data) => {
    toast.success("added Successfully!");
    return {
      type: WORK_PREFRENCE_SUCCESS,
      result: data,
      payload: false,
      msg: data.status.message,
    };
  };